import { useAuth } from "@clerk/react";

interface SystemOverviewProps {
  shipCount: number;
  avgSpeed: number;
  portCount: number;
}

function SystemOverview({ shipCount, avgSpeed, portCount }: SystemOverviewProps) {
  const { isSignedIn } = useAuth();

  return (
    <div className="space-y-2">
      <h4 className="font-semibold text-blue-400 tracking-wider uppercase">
        System
      </h4>
      <p>
        Ships Tracked:{" "}
        <span className="font-bold text-blue-300">{shipCount}</span>
      </p>
      <p>
        Avg Speed:{" "}
        {isSignedIn ? (
          <span className="font-bold text-blue-300">{avgSpeed} knots</span>
        ) : (
          <span className="font-bold text-gray-500">— knots</span>
        )}
      </p>
      <p>
        Ports Tracked:{" "}
        <span className="font-bold text-blue-300">{portCount}</span>
      </p>
    </div>
  );
}

export default SystemOverview;
